<template>
    <div class="string-fuse-tool__item">
        <div class="string-fuse-tool__header">
            <h3 class="lead">Inverter {{ inverter }}</h3>
            <span class="string-fuse-tool__mppt loz loz--ghost">MPPT {{ mppt.id }}</span>
            <span v-if="requiresFuse" class="string-fuse-tool__status">
                Fuse required
                <span class="string-fuse-tool__tick">
                    <svg class="icon h3"><use xlink:href="#tick" /></svg>
                </span>
                <tooltip class="ml-xs" text="All strings connected to this MPPT are required to have fuses applied to the positive and negative conductors prior to being paralleled." />
            </span>
            <span v-else class="string-fuse-tool__status">
                Fuse not required
                <span class="string-fuse-tool__tick bg--grey-dark">
                    <svg class="icon h3"><use xlink:href="#close" /></svg>
                </span>
            </span>
        </div>

        <div v-if="requiresFuse" class="string-fuse-tool__totals">
            <div>
                <p class="h1">{{ fuseSize.lower }}</p>
                <p class="small semi">
                    Fuse size: Lower (A)
                    <tooltip text="Fuse size lower is 1.5 x Isc of the PV module at STC" />
                </p>
            </div>
            <div>
                <p class="h1">{{ fuseSize.upper }}</p>
                <p class="small semi">
                    Fuse size: Upper (A)
                    <tooltip text="Fuse size upper is the lesser of '2.4 x the Isc of the PV module at STC' and the 'series fuse rating of the PV module'" />
                </p>
            </div>
        </div>

        <table class="string-fuse-tool__specs">
            <tr>
                <td>String in parallel</td>
                <td>{{ mppt.parallel }}</td>
            </tr>
            <tr>
                <td>Panels in series</td>
                <td>{{ mppt.series }}</td>
            </tr>
            <tr>
                <td>
                    <div class="flex">
                        PVAMV
                        <tooltip class="ml-xs" position="right" text="Ensure the voltage rating of the fuse/s is greater than the PVAMV of the MPPT" />
                        <span>Volts</span>
                    </div>
                </td>
                <td>{{ pvamv }}</td>
            </tr>
        </table>

        <template v-if="requiresFuse">
            <!-- <div class="string-fuse-tool__warn">
                <svg class="icon h3"><use xlink:href="#alert" /></svg>
                <p class="small semi">Ensure the voltage rating of the fuse/s is greater than the PVAMV of the MPPT</p>
            </div> -->

            <div v-if="fuseSize.lower > fuseSize.upper" class="string-fuse-tool__warn">
                <svg class="icon h3"><use xlink:href="#alert" /></svg>
                <p class="small semi">String fusing is not permissible as Fuse Size Lower Upper is greater than Fuse Size - please check string configuration/PV Module technical specs</p>
            </div>
        </template>
    </div>
</template>

<script>
import { find } from 'lodash';
import tooltip from '@/components/Tooltip';

export default {
    components: {
        tooltip
    },

    props: {
        inverter: {
            type: Number,
            required: true
        },

        mppt: {
            type: Object,
            required: true
        },

        products: {
            type: Array,
            required: true
        },

        temperature: {
            type: [Number, String],
            required: true
        }
    },

    computed: {
        requiresFuse() {
            const { details: { panelIsc, seriesFuseRating } } = find(this.products, ['id', this.mppt.panel.id]);
            return (this.mppt.parallel - 1) * (panelIsc * 1.25) > seriesFuseRating;
        },

        fuseSize() {
            if (!this.requiresFuse) return null;

            const { details: { panelIsc, seriesFuseRating} } = find(this.products, ['id', this.mppt.panel.id]);

            return {
                lower: Number.parseFloat(1.2 * panelIsc).toFixed(2),
                upper: Number(seriesFuseRating).toFixed(2)
            }
        },

        pvamv() {
            const { details: { voc, vDeratingCelsius } } = find(this.products, ['id', this.mppt.panel.id]);
            const pvMaxVoltage = Number(voc) + ((this.temperature - 25)  * (Number(voc) * Number(vDeratingCelsius) / 100));
            return Math.round(pvMaxVoltage * this.mppt.series);
        },
    }
}
</script>
